// src/lib/nameTypes.js — the kinds of name a partner submits through Add
// Names (migrations/071). Mirrors the server's src/lib/nameTypes.js.

export const NAME_TYPES = [
  { value: 'Capital raising',     label: 'Investor (capital raising)' },
  // partnerLabel: the portal's name for it (Matt, 11/3); see workTypes.js.
  { value: 'Strategic advisory',  label: 'Strategic advisory', partnerLabel: 'Strategic business development' },
  { value: 'Business Development / Client Acquisition', label: 'Business Development / Client Acquisition' },
]

// What the portal's Add Names offers (Matt, 11/3): no Strategic advisory
// type for partners. The CRM keeps all three; past names keep their type.
export const PORTAL_NAME_TYPES = NAME_TYPES.filter(t => t.value !== 'Strategic advisory')

export const nameTypeLabel = (v, partner) => {
  const t = NAME_TYPES.find(x => x.value === v)
  return (partner && t?.partnerLabel) || t?.label || v
}

// Business Development / Client Acquisition (renamed from "Client for a
// client", migrations/089): the same value as the Strategic Advisory work
// sub-type.
export const BUSINESS_DEVELOPMENT = 'Business Development / Client Acquisition'

// Preselected type for a mandate, from its work type and sub-type (signed
// EL). Every type stays available on every mandate; the partner may change
// it.
export function defaultNameType(workType, workSubtype) {
  const wt = workType || []
  const sub = workSubtype || []
  if (wt.includes('Financial Advisory')) return 'Capital raising'
  if (sub.includes(BUSINESS_DEVELOPMENT) && !sub.includes('General Advice')) return BUSINESS_DEVELOPMENT
  if (wt.includes('Strategic Advisory')) return 'Strategic advisory'
  return 'Capital raising'
}

// Extra fields for Business Development / Client Acquisition names
// (migrations/074; the columns keep their cfc_ prefix). Mirrors the
// server's CFC_RELATIONSHIP_TYPES.
export const CFC_RELATIONSHIP_TYPES = [
  'Customer', 'Distribution or channel partner', 'Supplier',
  'Strategic or JV partner', 'Acquirer', 'Other',
]

// The business development fields, in display order: the one place the
// partner form (PortalAddNames), the review panel and the CRM pipeline
// (MandateDetail) read them from. To change a field, edit it here and in
// the server's CFC_FIELDS (src/lib/nameTypes.js); a new field also needs a
// column on contact_submissions and mandate_name_pipeline (migrations/074,
// 075). Still to confirm with Emily (10/21).
export const CFC_FIELD_DEFS = [
  { key: 'cfc_relationship_type', label: 'Relationship to the client', kind: 'select', options: CFC_RELATIONSHIP_TYPES },
  { key: 'cfc_offering',          label: 'For which product or service', kind: 'text' },
  { key: 'cfc_market',            label: 'Location or market', kind: 'text', placeholder: 'e.g. UK financial services' },
  { key: 'cfc_size',              label: 'Size', kind: 'text', placeholder: 'Revenue or employees' },
]

// One line summarizing a row's business development fields.
export const cfcSummary = row => [
  row.cfc_relationship_type, row.cfc_offering && `for ${row.cfc_offering}`, row.cfc_market, row.cfc_size,
].filter(Boolean).join(' · ')
